var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"sb-area-select",staticClass:"sb-area-select"},[_c('el-cascader',_vm._g(_vm._b({attrs:{"props":_vm.props}},'el-cascader',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }